import React from 'react';
import styled from 'styled-components';
import { ValidExportDateFormat } from '../../../utils/export';
import { Column } from '../../layout/Column';
import { ControlLabel } from './ControlLabel';
import { SelectBox } from './SelectBox';

interface IExportDateFormatProps {
  onChange: (value: ValidExportDateFormat) => void;
  value: ValidExportDateFormat;
}

export const ExportDateFormat = (
  props: IExportDateFormatProps
): React.ReactElement => {
  const selectUs = (): void => props.onChange('MM/DD/YYYY');

  const selectWorld = (): void => props.onChange('DD/MM/YYYY');

  return (
    <Column>
      <ControlLabel>Date Format</ControlLabel>
      <Spacer>
        <SelectBox
          selected={props.value === 'MM/DD/YYYY'}
          onSelect={selectUs}
          label='MM/DD/YYYY'
        />
      </Spacer>
      <Spacer>
        <SelectBox
          selected={props.value === 'DD/MM/YYYY'}
          onSelect={selectWorld}
          label='DD/MM/YYYY'
        />
      </Spacer>
    </Column>
  );
};

const Spacer = styled.div`
  padding: 5px 0px;
`;
